import * as React from 'react';

import { Overrides } from './types';

const SelectContext = React.createContext<Overrides<any>>({});

export default SelectContext;
